import React from 'react';
import styles from './PopularTimes.module.css';
import { DigitalMapPin } from 'models/digitalMap';
import { useTranslation } from 'react-i18next';

const LiveInfo: React.FC<{ pin: DigitalMapPin }> = ({ pin }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.liveInfo}>
      <img src="/static/images/map/live_icon.svg" className={styles.liveIcon} alt="" />
      <p>
        <span className={`${styles.bold} ${styles.highlight}`}>{t('Live: ')}</span>
        {pin.is_closed ? (
          <span className={styles.bold}>
            {pin.closed_text ||
              t('Closed', {
                context: 'waitTime',
              })}
          </span>
        ) : i18n.language === 'ja-JP' ? (
          <>
            現在の待ち時間<span className={styles.bold}>{pin.wait_time}分</span>
          </>
        ) : (
          <>
            Current wait time is <span className={styles.bold}>{pin.wait_time} minutes</span>.
          </>
        )}
      </p>
    </div>
  );
};

export default LiveInfo;
